module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zx-box"
  }, [_c('div', {
    staticClass: "zx-box-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/zhibojian_zaixianguanzhong@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.zaixianguanzhong')) + "：" + _vm._s(_vm.total))])]), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "zx-box-list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zx-box-list-item",
      on: {
        "click": function($event) {
          return _vm.handleShowUser(item.userId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-051e393e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/zaixianguanzhong/zaixianguanzhong.vue
// module id = 946
// module chunks = 1